export default "__VITE_ASSET__f0923ce1__"